export default "__VITE_ASSET__Fkp7slfJ__"